import { Hero } from "../components/Hero";
import { ProductGrid } from "../components/ProductGrid";
import { FloatingContact } from "../components/FloatingContact";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Hero />
            <ProductGrid />
            <FloatingContact />
        </main>
    );
}
